import qs from "qs";
import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { caseMapMachinesKey } from "components/CaseMap/queryKeys";
import { useMachineStatusMutation } from "hooks/useMachineStatusMutation";

/**
 * The map's status mutation, bound to the page the map is currently showing.
 *
 * Resolves the query key from the route and the URL filters rather than taking
 * it as a prop, so a status control can sit anywhere in the tree. React Query
 * hashes keys structurally, so rebuilding the key here still reaches the very
 * cache entry `useCaseMapMachines` is reading.
 */
export function useCaseMapStatusChange() {
  const { id: caseRouteId } = useParams();
  const [searchParams] = useSearchParams();

  const filterParams = useMemo(
    () => qs.parse(searchParams.toString()),
    [searchParams]
  );

  return useMachineStatusMutation(
    caseMapMachinesKey(caseRouteId, filterParams)
  );
}
